// import React, {  useContext } from 'react';
// import MenuContext from './MenuContext'


// export default function StageNavigator() {
//     const { activeTab , setActiveTab } = useContext(MenuContext);

//     const NextStep = (tab) => {
//         var number = tab.match(/\d+/)[0]; 
//         setActiveTab(`Stage${Number(number)+1}`);
//     }

//     const PreviousStep = () => {
//         var number = activeTab.match(/\d+/)[0]; 
//         setActiveTab(`Stage${Number(number)-1}`);
//     }


//     return (
//          <div className='container mycontainer'>
//             <div className="row">
//                <div className="col-md-6 col-sm-6 col-xs-6">
//                     <div className="form-group1">
//                     { !['Stage1','Stage7'].includes(activeTab) &&     <div className="prevbtn"><a onClick={PreviousStep}  > <iconify-icon icon="iconamoon:arrow-left-2-duotone"></iconify-icon>Previous</a></div>}
//                     </div>
//                 </div>
//                 <div className="col-md-6 col-sm-6 col-xs-6">
//                     <div className="form-group1">
//                         { !['Stage7'].includes(activeTab) &&   <div className="nextbtn"><a onClick={()=>NextStep(activeTab)}>Next <iconify-icon icon="iconamoon:arrow-right-2-bold"></iconify-icon></a></div>}
//                     </div>
//                 </div>
//             </div>
//             </div>
//     )
// }

import React, { useContext } from "react";
import MenuContext from "./MenuContext";
import { getCookie } from "../../services/DataRequestService";

export default function StageNavigator() {
    const { activeTab, setActiveTab } = useContext(MenuContext);

    const NextStep = (tab) => {
        let number = parseInt(tab.match(/\d+/)[0], 10); // Extract the current stage number
        let nextStage = number + 1;

        // Clear localStorage if it's Stage4
        if (nextStage === 4) {
            localStorage.removeItem(getCookie("sub") + "tableData");
        }

        // Skip Stage5
        // if (nextStage === 5) {
        //     nextStage = 6;
        // }

        setActiveTab(`Stage${nextStage}`);
    };
    const PreviousStep = () => {
        let number = parseInt(activeTab.match(/\d+/)[0], 10); // Extract the current stage number
        let previousStage = number - 1;

        // Skip Stage5
        // if (previousStage === 5) {
        //     previousStage = 4;
        // }

        setActiveTab(`Stage${previousStage}`);
    };

    return (
        <div className="container mycontainer">
            <div className="row">
                <div className="col-md-6 col-sm-6 col-xs-6">
                    <div className="form-group1">
                        {!["Stage1", "Stage7"].includes(activeTab) && (
                            <div className="prevbtn">
                                <a onClick={PreviousStep} className="cursor-pointer">
                                    <iconify-icon icon="iconamoon:arrow-left-2-duotone"></iconify-icon>Previous
                                </a>
                            </div>
                        )}
                    </div>
                </div>
                <div className="col-md-6 col-sm-6 col-xs-6">
                    <div className="form-group1">
                        {!["Stage7"].includes(activeTab) && (
                            <div className="nextbtn">
                                <a onClick={() => NextStep(activeTab)} className="cursor-pointer">
                                    Next <iconify-icon icon="iconamoon:arrow-right-2-bold"></iconify-icon>
                                </a>
                            </div>
                        )}
                    </div>
                </div>
            </div>
        </div>
    );
}

